import styled from '@emotion/styled';
import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import { Button as BootstrapButton, ButtonProps as BootstrapButtonProps } from 'reactstrap';
import { observer } from 'mobx-react';
import { Theme } from '../Theme/Theme';

const StyledButton = styled(BootstrapButton)`
  border-radius: 8px;
  border-width: 2px;
  font-weight: 600;
  letter-spacing: -0.18px;
  line-height: 14px;
  color: #fff;
  font-size: ${({ size }) => (size === 'sm' ? '0.8em' : '1em')};
  padding: ${({ size }) => (size === 'sm' ? '10px 16px' : '20px 32px')};
  ${({ shadowed }) => (shadowed ? 'box-shadow: 0px 0px 0px 1px #abf8e1;' : '')}

  &:hover {
    // ${({ disabled }) => (disabled ? '' : 'cursor: pointer')};
  }

  &.btn-primary,
  &.btn-success {
    background-color: ${Theme.Colors.primary};
    border-color: ${Theme.Colors.primary};
    color: ${Theme.Colors.primaryText};
    box-shadow: 0 0 0 1px #abf8e1;

    &:active,
    &:hover {
      background-color: ${Theme.Colors.primaryDark};
      border-color: ${Theme.Colors.primaryDark};
      color: ${Theme.Colors.primaryText};
    }
  }

  &.btn-primary.disabled,
  &.btn-success.disabled,
  &:active.disabled,
  &:hover.disabled {
    background-color: rgba(0, 0, 0, 0.5);
    border-color: rgba(0, 0, 0, 0.5);
    color: ${Theme.Colors.white};
    box-shadow: none;
    pointer-events: inherit;
    cursor: inherit;
  }

  &.btn-danger {
    background-color: #dc3545;

    &:active {
      background-color: #dc3545;
      border-color: #dc3545;
    }
  }

  &.btn-secondary {
    background-color: ${Theme.Colors.lightestGrey};
    color: ${Theme.Colors.black};
    border: none;

    &:hover,
    &:active {
      background-color: ${Theme.Colors.lightestGrey};
      border: none;
      color: ${Theme.Colors.black};
    }
  }

  &.btn-link {
    color: black;
    border-width: 0;
  }

  &.btn-warning {
    background-color: #f0a44b;
    color: black;
  }

  @media (min-width: 600px) {
    font-size: 1em;
    padding: 20px 32px;
  }
`;

export type ButtonProps = Omit<BootstrapButtonProps, 'value'> & {
  block?: boolean;
  value?: string | null;
  size?: 'sm';
  shadowed?: boolean;
};

export const Button: React.FC<PropsWithChildren<ButtonProps>> = observer(
  ({ value, color = 'primary', children, ...moreProps }) => {
    return (
      <StyledButton {...moreProps} color={color}>
        {children ?? String(value).toUpperCase()}
      </StyledButton>
    );
  },
);
